import urlParser from 'bloko/common/urlParser';

import paths from 'src/app/routePaths';

export const getUrlWithoutVacancy = (urlSearchParams: string): string => {
    const urlParsed = urlParser(paths.resumeSearch + urlSearchParams);
    delete urlParsed.params.context_vacancy_id;
    return urlParsed.href;
};
